import axios from 'axios';
import { UpdateFeederInput } from 'views/self-service/features/feeders/types/update-feeder-input.type';

// PUT Feeder
// /ewosapi/v1/shrimps/feeder/{globalCompanyId}
export const putFeeder = async (globalCompanyId: string, feederId: number, request: UpdateFeederInput) => {
  const res = await axios.put(`/ewosapi/v1/shrimps/feeder/${globalCompanyId}/${feederId}`, request);
  return res.data;
};
